export const INITTEST = "INITTEST";
export const GETQUESTIONNAIRE = "GETQUESTIONNAIRE";
export const SENDQUESTIONNAIRE = "SENDQUESTIONNAIRE";
export const GETPATIENTS = "GETPATIENTS";
export const DELETEPATIENT = "DELETEPATIENT";
export const RESETPATIENT = "RESETPATIENT";
export const RESETQUESTIONNAIRE = "RESETQUESTIONAIRE";
export const RESETPATIENTS = "RESETPATIENTS";
